import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { updateGigApi } from "../../API/API"

function* updateGigSaga(params) {
    try {
        const response = yield call(updateGigApi, params.payload);
        yield put({ type: types.UPDATE_GIG_SUCCESS, payload: response.data });
    }
    catch (error) {
        yield put({ type: types.UPDATE_GIG_FAILURE, error });
    }
}

export function* watchUpdateGigSaga() {
    yield takeEvery(types.UPDATE_GIG_REQUESTED, updateGigSaga);
}